{
  "assetContainerEvent": {
    "types": {
      "arrived": "Arrived",
      "arrivedWaiting": "Arrived/Waiting",
      "loading": "Loading",
      "loadingComplete": "Loading Complete",
      "unloading": "Unloading",
      "unloadingComplete": "Unloading Complete",
      "readyForPickup": "Ready for Pickup",
      "departed": "Departed",
      "inoperable": "Inoperable",
      "missing": "Missing",
      "inTransit": "In Transit"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "Arrived",
    "Docked": "Docked",
    "Parked": "Parked",
    "Unassigned": "Unassigned",
    "Dropped": "Dropped",
    "Hooked": "Hooked",
    "Appointment Linked": "Appointment Linked",
    "Appointment Unlinked": "Appointment Unlinked",
    "Status Updated": "Status Update"
  },
  "assetContainerTypes": {
    "trailer": "Trailer",
    "container": "Container",
    "oversized": "Oversized",
    "chassis": "Chassis",
    "reefer": "Reefer",
    "other": "Other"
  },
  "assetVisitTypes": {
    "live": "Live",
    "drop": "Drop",
    "pickup": "Hook",
    "dropHook": "Drop & Hook"
  },
  "assetVisitDirections": {
    "inbound": "Inbound",
    "outbound": "Outbound",
    "inboundAndOutbound": "In & Out"
  },
  "loadTypeDirections": {
    "inbound": "Inbound",
    "outbound": "Outbound",
    "inOut": "Inbound & outbound",
    "load": "Load",
    "unload": "Unload",
    "dropOff": "Drop off",
    "pickUp": "Pick up",
    "dropAndHook": "Drop & hook",
    "inboundAndOutbound": "Inbound & outbound"
  },
  "loadTypeOperations": {
    "live": "Live",
    "drop": "Drop",
    "other": "Other"
  },
  "loadTypeTypes": {
    "standard": "Standard",
    "preparation": "Preparation"
  },
  "altAssetVisitTypes": {
    "unknown": "Unknown"
  },
  "assetContainerStates": {
    "full": "Full",
    "empty": "Empty",
    "partiallyLoaded": "Partially Loaded"
  },
  "spotStatuses": {
    "open": "open",
    "closed": "closed",
    "assigned": "assigned",
    "inTransit": "in transit",
    "reservedManual": "reserved",
    "reservedAutomated": "reserved",
    "unknown": "unknown"
  },
  "spotTypes": {
    "parking": "parking",
    "docking": "docking"
  },
  "labels": {
    "licensePlate": "License Plate",
    "dotNumber": "DOT Number"
  },
  "messages": {
    "unknownCompany": "Unknown Company",
    "unhooked": "Unhooked",
    "noInformationAvailable": "No information available",
    "noVisitFound": "No visit found",
    "notInformed": "Not informed",
    "waitingAssignment": "Waiting assignment",
    "failedToLoadSpotDetails": "Failed to load spot details",
    "retry": "Retry",
    "blockedUntilSpotIsOpen": "Blocked until {spot} is open",
    "blockReasons": {
      "reservedByOther": "Destination spot is **reserved** to **Move Task #{taskNumber}**.",
      "reservedByOtherGeneric": "Destination spot is **reserved**.",
      "destinationClosed": "Destination spot is **closed**.",
      "destinationOccupied": "Destination spot is **occupied** by another asset.",
      "anotherAssetInTransitForDestination": "**{assetCode}** is already in transit to this spot.",
      "assetInTransitElsewhere": "Asset already being moved by another move task."
    }
  }
}
